import React from 'react';

export default function signUp() {
  return <div className="">회원가입</div>;
}
